<script>
    import { mapGetters } from "vuex";
    import logo from "../assets/gota.svg";
    import FBottomSheet from "./FBottomSheet";

    export default {
        name: "FFooter",
        components: { FBottomSheet },
        props: {
            companyName: {
                type: String,
                default: ""
            },

            renderMenuIcon: {
                type: Boolean,
                default: false
            }
        },

        data: () => ({
            logo
        }),

        computed: {
            ...mapGetters(["companySelected"])
        }
    };
</script>


<template>
    <v-footer class='pa-2 fluid__footer' app>
        <!-- <img :src='logo' class='fluid__footer__logo' alt='Logo do aplicativo Fluid'> -->
        <span class='font-weight-bold' style='color: #fff'>{{ companySelected.pessoa.nomeFantasia }}</span>

        <v-spacer/>

        <FBottomSheet v-if='renderMenuIcon' activatorColor='#ffffff'/>
    </v-footer>
</template>

<style scoped>
    .fluid__footer {
        height: 4vh !important;
        padding: 0 10px 0 10px;
    }
    .fluid__footer__logo {
        height: 25px;
        object-fit: contain;
        margin-right: 5px;
    }
    .theme--light.application .fluid__footer {
        background-color: #063e5f;
    }
    .theme--dark.application .fluid__footer__logo {
        filter: brightness(9999);
    }
</style>
